export default __webpack_public_path__ + "static/media/moldavia.697d9af4.svg";